const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalkin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66666 3.50065C9.39999 3.50065 9.99999 2.90065 9.99999 2.16732C9.99999 1.43398 9.39999 0.833984 8.66666 0.833984C7.93332 0.833984 7.33332 1.43398 7.33332 2.16732C7.33332 2.90065 7.93332 3.50065 8.66666 3.50065ZM6.19999 5.76732L4.33332 15.1673H5.73332L6.93332 9.83398L8.33332 11.1673V15.1673H9.66666V10.1673L8.26666 8.83398L8.66666 6.83398C9.53332 7.83398 10.8667 8.50065 12.3333 8.50065V7.16732C11.0667 7.16732 9.99999 6.50065 9.46666 5.56732L8.79999 4.50065C8.42666 3.90732 7.67999 3.66732 7.03332 3.94065L3.66666 5.36732V8.50065H4.99999V6.23398L6.19999 5.76732Z",
    fill: "#0057B8",
    style: {
      fill: "#0057B8",
      fill: "color(display-p3 0.0000 0.3412 0.7216)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkin);
export default __webpack_public_path__ + "static/media/walkin.4b6fb07996225947ef591c1267384b6e.svg";
export { ForwardRef as ReactComponent };